var login = {
  translation: {
    common: {
      accept: 'Acceptera',
      alreadyUser: 'Redan användare?',
      and: 'och',
      backToLogin: 'Tillbaka till inloggningssidan',
      continueWith: 'Fortsätt med {{provider}}',
      createAccount: 'Skapa ett konto',
      createYourAccount: 'Skapa ditt konto',
      emailOrUsername: 'E-post eller användarnamn',
      login: 'Logga in',
      logInToBoards: 'Logga in',
      newToBoards: 'Ny på 4ga Boards?',
      pageNotFound_title: 'Sidan hittades inte',
      password: 'Lösenord',
      privacyPolicy: 'Integritetspolicy',
      register: 'Registrera',
      registerWithGoogle: 'Registrera med Google',
      termsOfService: 'Användarvillkor',
      togglePasswordVisibility: 'Visa/dölj lösenord',
    },

    action: {
      logIn: 'Logga in',
    },
  },
};

export { login as default };
